define('core/views/TwitterRichMediaView',[
    'underscore',
    'core/views/DynamicHeightRichMediaView',
    'core/templates/postMediaTwitterContent',
], function (
    _,
    DynamicHeightRichMediaView,
    postMediaTwitterContentTemplate
) {
    'use strict';

    var TwitterRichMediaView = DynamicHeightRichMediaView.extend({
        // TwitterRichMediaView generates content html from scratch
        // (ignores server html). It then themes the content to match the embed.

        generateContentHtml: function () {
            // Twitter uses two-character ISO 639-1 codes for the language option.
            // See https://dev.twitter.com/docs/api/1.1/get/help/languages.
            var language = window.document.documentElement.lang;
            language = language && language.substring(0, 2);

            var url = this.media.get('url');
            if (this.media.get('resolvedUrl').indexOf('/status') !== -1)
                url = this.media.get('resolvedUrl');

            return postMediaTwitterContentTemplate({
                url: url,
                theme: _.result(TwitterRichMediaView, 'theme'),
                linkColor: _.result(TwitterRichMediaView, 'linkColor'),
                language: language,
            });
        },
    }, {
        theme: 'light', // either 'light' or 'dark'
        linkColor: '#2e9fff', // this is the default used by Disqus Home
    });

    return TwitterRichMediaView;
});

